import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './DublinRoofingSection.css';
import '../all/Main.css';

import dublin from '../../../assets/ColumbusPage/Storm Damage/Storm_damage_columbus_ohio_yesterday_UltimatesRoofing.jpg';
import dublina from '../../../assets/ColumbusPage/Roof Installation/Roof_Installation_Columbus_Ohio_Ultimatesroofing.jpg';
import dublin1 from '../../../assets/ColumbusPage/Roof Replacement/Roof_Replacement_Columbus_Ohio_ultimatesroofing.jpg';
import dublin2 from '../../../assets/ColumbusPage/Roof Repair/Residential_roof_repair_Columbus_Ultimatesroofing.jpg';
import dublin3 from '../../../assets/ColumbusPage/Gutter/Roof_gutters_columbus_ohio.jpg';
import dublin4 from '../../../assets/ColumbusPage/Siding/siding_repair_columbus_ohio.jpg';

import AnimatedButton from '../RoofingSection/AnimatedButton';
import Badge from '../ServiceSection/Badge';
import { Link } from 'react-router-dom';

const DublinRoofingSection = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const cardEls = useRef([]);
  const [scrollProg, setScrollProg] = useState(0);

  const services = [
    {
      title: "Roof Repair",
      desc: "Fast solutions to stop leaks, restore integrity, and prevent costly structural damage.",
      icon: "bi-layers",
      image: dublin
    },
    {
      title: "Roof Replacement",
      desc: "Complete roof replacement using durable materials for long-term home protection.",
      icon: "bi-shield-check",
      image: dublina
    },
    {
      title: "Roof Installation",
      desc: "Professional installation for new construction or roofing system upgrades.",
      icon: "bi-tools",
      image: dublin1
    },
    {
      title: "Storm Damage Repair",
      desc: "Hail, wind, and water damage repair restoring roofs after severe weather events.",
      icon: "bi-cloud-rain-heavy",
      image: dublin2
    },
    {
      title: "Gutters",
      desc: "Gutter repairs ensuring proper drainage and preventing foundation water damage.",
      icon: "bi-droplet-half",
      image: dublin3
    },
    {
      title: "Siding",
      desc: "Durable siding installation improving insulation, appearance, and weather resistance.",
      icon: "bi-arrow-repeat",
      image: dublin4
    }
  ];

  const particles = useRef(
    Array.from({ length: 18 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: 55 + Math.random() * 45,
      size: 2 + Math.random() * 3,
      dur: 7 + Math.random() * 10,
      delay: Math.random() * 8
    }))
  ).current;

  useEffect(() => {
    const observers = [];

    // Header animation
    if (headerRef.current) {
      const headerObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            entry.target
              .querySelectorAll('.roofing-badge,.roofing-title,.dublin-desc')
              .forEach(el => el.classList.add('animate-in'));

            headerObserver.disconnect();
          }
        },
        { threshold: 0.2 }
      );

      headerObserver.observe(headerRef.current);
      observers.push(headerObserver);
    }

    // Card animations
    cardEls.current.forEach((card, i) => {
      if (!card) return;

      const cardObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, i * 120);

            cardObserver.disconnect();
          }
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      cardObserver.observe(card);
      observers.push(cardObserver);
    });

    return () => observers.forEach(obs => obs.disconnect());
  }, []);

  // Scroll progress
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      const height = rect.height;

      const progress = Math.min(
        Math.max(
          (window.scrollY - top + window.innerHeight * 0.5) / height,
          0
        ),
        1
      );

      setScrollProg(progress * 100);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCardMouse = useCallback((e, idx) => {
    const card = cardEls.current[idx];
    if (!card) return;

    const rect = card.getBoundingClientRect();

    card.style.setProperty(
      '--mx',
      `${((e.clientX - rect.left) / rect.width) * 100}%`
    );

    card.style.setProperty(
      '--my',
      `${((e.clientY - rect.top) / rect.height) * 100}%`
    );
  }, []);

  return (
    <section className="cs-section roofing-section" ref={sectionRef}>
      {/* Particles */}
      <div className="roofing-particles" aria-hidden="true">
        {particles.map((p) => (
          <div
            key={p.id}
            className="roofing-particle"
            style={{
              left: `${p.left}%`,
              top: `${p.top}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              animationDuration: `${p.dur}s`,
              animationDelay: `${p.delay}s`
            }}
          />
        ))}
      </div>

      {/* Scroll line */}
      <div
        className="roofing-scroll-line"
        style={{ width: `${scrollProg}%` }}
      />

      <div className="container position-relative" style={{ zIndex: 2 }}>
        {/* Header */}
        <div className="roofing-header" ref={headerRef}>
          <div className='cs-badge d-flex justify-content-lg-start justify-content-center'>
        <Badge text="Roofing Services"></Badge></div>

          <h2
            className="cs-title roofing-title col-lg-9 col-12 text-white text-lg-start text-center"
           
          >
            Our Roofing Services Available
            <span className=""> in Columbus, Ohio</span>
          </h2>

          <p className="cs-desc dublin-desc text-lg-start text-center">
            We provide complete roofing services for homeowners and business
            owners across Columbus, ensuring durability, safety, and long-term
            property protection.
          </p>
        </div>

        {/* Cards - WITH IMAGE HOVER ICON EFFECT */}
        <div className="row g-4 cs-content">
          {services.map((service, i) => (
            <div className="col-lg-4 col-md-6" key={service.title}>
              <div
                ref={el => (cardEls.current[i] = el)}
                className="roofing-card"
                onMouseMove={(e) => handleCardMouse(e, i)}
              >
                <div className="roofing-card-shine" />
                <span className="roofing-card-num">
                  {String(i + 1).padStart(2, '0')}
                </span>

                {/* IMAGE HOVER → ICON BG CHANGE */}
                <div 
                  className="roofing-card-img-wrap"
                  onMouseEnter={() => {
                    const icon = cardEls.current[i]?.querySelector('.roofing-card-icon');
                    icon?.classList.add('icon-hover');
                  }}
                  onMouseLeave={() => {
                    const icon = cardEls.current[i]?.querySelector('.roofing-card-icon');
                    icon?.classList.remove('icon-hover');
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                  />
                </div>

                <div className="roofing-card-content">
                  <div className="roofing-card-icon">
                    <i className={`bi ${service.icon}`} />
                  </div>

                  <h3 className="roofing-card-title">
                    {service.title}
                  </h3>

                  <p className="roofing-card-desc">
                    {service.desc}
                  </p>

<Link
  to="/siding-enhancements"
  className="roofing-card-link"
>
  Learn More
  <i className="bi bi-arrow-right" />
</Link>

    

                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-lg-3 mt-4 d-flex justify-content-center">
          <AnimatedButton />
        </div>
      </div>
    </section>
  );
};

export default DublinRoofingSection;